import { makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/styles';
import * as React from 'react';
import { ActionIcon } from '../../../ActionIcon';
import { HeaderButton } from '../HeaderButton';
const useStyles = makeStyles({
    icon: {
        padding: 0,
    },
});
const HeaderIconButton = (props) => {
    const { disabled, actionIconProps, testId = 'HeaderIconButton-' + props.actionIconProps.iconName, onClick } = props;
    const classes = useStyles();
    const theme = useTheme();
    return (React.createElement(HeaderButton, { disabled: disabled, onClick: onClick, testId: testId },
        React.createElement(ActionIcon, Object.assign({ testId: `${testId}-icon`, className: classes.icon, onClick: () => null, iconSize: 24, color: theme.color.font.light, contrastColor: theme.color.brand.main, labelSize: theme.font.size.small }, actionIconProps))));
};
export default HeaderIconButton;
//# sourceMappingURL=HeaderIconButton.js.map